import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const Certifications = () => {
  const { t } = useLanguage();

  const certificates = [
    {
      id: 1,
      title: 'Beyond Success',
      issuer: 'Certificate',
      file: '/images/Certification/Beyond_Sucess.png',
      isImage: true
    },
    {
      id: 2,
      title: 'System Analysis and Design',
      issuer: 'Certificate',
      file: '/images/Certification/System_Analysis_and_Design.png',
      isImage: true
    },
    {
      id: 3,
      title: 'Modern DevOps in Practice',
      issuer: 'Certificate',
      file: '/images/Certification/Modern_DevOps_In_Practice.png',
      isImage: true
    }
  ];

  const handleView = (e, cert) => {
    e.preventDefault();
    const fileName = cert.file.split('/').pop();
    const win = window.open('', '_blank');
    if (win) {
      win.document.write(`
        <html>
          <head>
            <title>${cert.title}</title>
            <style>
              body { margin: 0; background: #000; display: flex; align-items: center; justify-content: center; min-height: 100vh; }
              img { max-width: 100%; max-height: 100vh; object-fit: contain; }
            </style>
          </head>
          <body>
            <img src="${cert.file}" alt="${cert.title}" />
          </body>
        </html>
      `);
      win.document.close();
    }
  };

  return (
    <motion.div
      className="page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <section className="section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            <h2 className="section-title">{t('nav.certifications')}</h2>
          </motion.div>

          <div className="projects-grid">
            {certificates.map((cert, index) => (
              <motion.div
                key={cert.id}
                className="project-card"
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.1 * index }}
              >
                <div className="project-image">
                  <img src={cert.file} alt={cert.title} />
                </div>
                <div className="project-content">
                  <h3>{cert.title}</h3>
                  <p>{cert.issuer}</p>
                  <div className="project-links">
                    <a href="#" onClick={(e) => handleView(e, cert)} className="project-link">
                      View Certificate
                    </a>
                    <a href={cert.file} download className="project-link">
                      Download
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default Certifications;
